import { useGridApiRef } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import Table from "../../../../components/generic-table";
import { useGroups } from "../../../../hooks/groups";
import { language } from "../../../../language";

const FETCH_STATE = {
  firstResult: 0,
  pageSize: 10,
  sortBy: "id",
  sortOrder: "asc",
  searchTerm: "",
};

const GroupSelectListPage = ({ selectedgroups, onchangeGroupSelect }) => {
  const apiRef = useGridApiRef();

  useEffect(() => {
    const groups = selectedgroups ? Object.keys(selectedgroups) : [];
    const selecteds = { type: "include", ids: new Set(groups) };
    apiRef.current.setRowSelectionModel(selecteds);
  }, [selectedgroups]);

  const [pagination, setPagination] = useState(FETCH_STATE);

  const { data: groupList } = useGroups({
    params: pagination,
  });

  const handleChange = (data) => {
    onchangeGroupSelect(data);
  };

  const dataTable = {
    title: language.groups,
    headers: [
      { title: language.id, field: "id" },
      { title: language.name, field: "name" },
    ],
    actions: [],
    data: groupList?.content,
  };

  const dataPagination = {
    callData: setPagination,
    totalElements: groupList?.totalElements,
    model: {
      ...pagination,
      count: groupList?.size,
      sortHeader: FETCH_STATE.sortBy,
    },
  };

  if (groupList?.content && Object.keys(selectedgroups).length > 0) {
    const keys = Object.keys(selectedgroups);
    groupList.content.forEach((element) => {
      if (keys.includes(element.id)) {
        element.tableData = { id: element.id, checked: true };
      }
    });
  }

  return (
    <div>
      <Table
        apiRef={apiRef}
        tableData={dataTable}
        paginationMode="server"
        pagination={dataPagination}
        onRowSelectionModelChange={handleChange}
        checkboxSelection
      />
    </div>
  );
};

GroupSelectListPage.propTypes = {
  selectedgroups: PropTypes.object.isRequired,
  onchangeGroupSelect: PropTypes.func.isRequired,
};

export default GroupSelectListPage;
